import * as PIXI from 'pixi.js'
import gsap from 'gsap'
import { GlowFilter } from 'pixi-filters'

import AssetsManager from '../../../pixi/AssetsManager'
import CardModel from '../data/CardModel'
import CardView from './CardView'
import TouchUtil from '../../../util/TouchUtil'

/**
 * Stacsクラス
 */
class Stacs extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  //コンテナ
  private _container: PIXI.Container

  //グローフィルター
  private _glowFilter: GlowFilter

  //bindされたカード選択メソッド
  private _onCardSelect: any

  // ---------------------------------------------------------------------------------------------------------
  // --	Stacs
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    //カード選択時の処理
    this._onCardSelect = this.onCardSelect.bind(this)

    //影
    const shadow: PIXI.Sprite = AssetsManager.instance.createSpriteByName('card_shadow.png')
    shadow.anchor.set(0.5)
    shadow.scale.set(3.0)
    shadow.alpha = 0.2
    this.addChild(shadow)

    //コンテナ配置
    this._container = new PIXI.Container()
    this.addChild(this._container)

    //グローフィルター
    this._glowFilter = new GlowFilter({
      distance: 15,
      outerStrength: 2,
      innerStrength: 0,
      color: 0xffff00,
      quality: 0.5,
    })
  }

  /**
   * 初期化
   */
  public init(models: Array<CardModel>): void {
    //モデルのViewを配置
    for (let index = 0; index < models.length; index++) {
      const model: CardModel = models[index]
      const card: CardView = model.view
      card.x = 0
      card.y = 10 * index
      this._container.addChild(card)
      card.on('pointerdown', this._onCardSelect)
    }
  }

  /**
   * カード選択
   */
  public onCardSelect(e: PIXI.FederatedPointerEvent): void {
    // console.log(e)

    //タッチID保持
    if (TouchUtil.touchID != -1) return
    TouchUtil.touchID = e.pointerId

    //タッチ位置を保存
    TouchUtil.global.copyFrom(e.global)

    //カードのインデックスを取得
    const card: CardView = e.target as CardView
    const index: number = this._container.getChildIndex(card)

    //取得するカードの配列
    const cards: Array<CardView> = []
    for (let i = index; i < this._container.children.length; i++) {
      const card: CardView = this._container.getChildAt(i) as CardView
      card.off('pointerdown')
      cards.push(card)
    }

    //イベント発行
    this.emit('SELECT_CARD' as any, { target: this, cards: cards })
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	METHODS
  // ---------------------------------------------------------------------------------------------------------

  /**
   * カードを開く
   */
  public open(): void {
    if (this._container.children.length == 0) return

    //一番上のカードをフリップさせる
    const card: CardView = this._container.getChildAt(
      this._container.children.length - 1
    ) as CardView
    if (!card.isOmote) card.flip(true)
  }

  /**
   * カードを追加する
   */
  public addCards(cards: Array<CardView>): void {
    //前のカードの座標計算
    let posY: number = 0
    if (this._container.children.length > 0) {
      //最後のカードを取得
      const lastCard: CardView = this._container.getChildAt(
        this._container.children.length - 1
      ) as CardView
      posY = lastCard.y
      posY += lastCard.isOmote ? 40 : 10
    }

    //カードをコンテナに追加
    for (let i = 0; i < cards.length; i++) {
      //カード参照
      const card: CardView = cards[i]

      //ローカル座標に変換して配置
      const globalCardPos: PIXI.Point = card.parent.toGlobal(card.position)
      const localPos: PIXI.Point = this.toLocal(globalCardPos)
      card.x = localPos.x
      card.y = localPos.y
      this._container.addChild(card)

      //アニメーション
      gsap.to(card, {
        x: 0,
        y: posY,
        duration: 0.1,
        ease: 'power2.out',
        onComplete: () => {
          card.on('pointerdown', this._onCardSelect)
        },
      })

      //座標更新
      posY += card.isOmote ? 40 : 10
    }
  }

  // ---------------------------------------------------------------------------------------------------------
  // --	UTILs
  // ---------------------------------------------------------------------------------------------------------

  /**
   * ドラッグ中のカードとのヒットテスト
   */
  public hitTest(pos: PIXI.Point): boolean {
    // if (this._container.children.length == 0) return false

    const bounds: PIXI.Rectangle = this.getBounds()
    if (bounds.contains(pos.x, pos.y)) {
      this.filters = [this._glowFilter]
      return true
    } else {
      this.filters = []
      return false
    }
  }

  /**
   * フォーカスを外す
   */
  public unfocus(): void {
    this.filters = []
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Stacs
